export const MEMBERSHIP_FLOW_SET_MEMBERSHIP_PROGRAM =
	'MEMBERSHIP_FLOW_SET_MEMBERSHIP_PROGRAM'
export const MEMBERSHIP_FLOW_SET_MEMBERSHIP_CLUB =
	'MEMBERSHIP_FLOW_SET_MEMBERSHIP_CLUB'
